module.exports = __webpack_public_path__ + "img/logo.359af17c.png";